import { setDefaultStyle, strokeWidth } from "apparatus/draw";
import { P, Segments, SharedColors } from "apparatus/library/common";
import { Group, Path, Symbol } from "paper";
import { condenserCaseShape } from "../condensers";
export class Vigreux {
    render(appearance) {
        const { group: graphic, snap } = condenserCaseShape(230, 15);
        setDefaultStyle(graphic);
        const perf = new Symbol(perforation());
        for (let y = 40; y < 200; y += 30) {
            graphic.addChild(perf.place(P(0, y)));
        }
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            snapping: snap,
        };
    }
}
Vigreux.properties = {
    label: "Vigreux Column",
    defaultAppearance: {},
    appearanceSpecs: [],
};
function perforation() {
    // Straight triangles.
    const triangle1l = new Path(Segments([[-18, 0]], [[-8, 5]], [[-18, 10]]));
    const triangle1r = triangle1l.clone();
    triangle1r.scale(-1, 1, P(0, 0));
    const circle = new Path.Circle(P(0, 5), 4);
    // Bent triangles
    const triangle2l = new Path(Segments([[-18, 15]], [[-8, 25], [0, -9], [0, -6]], [[-18, 25]]));
    const triangle2r = triangle2l.clone();
    triangle2r.scale(-1, 1, P(0, 0));
    const drop = new Path(Segments([[0, 15], [-8, 0], [8, 0]], [[0, 25]])).close();
    const group = new Group([triangle1l, triangle1r, triangle2l, triangle2r, circle, drop]);
    group.withStroke(strokeWidth("thinner"), SharedColors.glassFold);
    return group;
}
